import { useCallback, useRef, useLayoutEffect } from 'react';
import useRouter from '@sift/resift/useRouter';
import { PERSON_ENTITY_TYPE_KEY } from 'helpers/useEntityTypes';
import {
  HOME_URL,
  ATTRIBUTES_URL,
  DYNAMIC_PAGES_URL,
  PERSON_PROFILE_URL,
} from 'components/Router/consts';

export default function useAttributesEditDialog(entityTypeKey: string) {
  const { location, history } = useRouter();

  // put history into a ref to help preserve function pointers
  const historyRef = useRef(history);
  useLayoutEffect(() => {
    historyRef.current = history;
  }, [history]);

  const isOpen =
    location.pathname.includes(`/attributes/${entityTypeKey}/create`) ||
    location.pathname.includes(`/attributes/${entityTypeKey}/choose`) ||
    location.pathname.includes(`/attributes/${entityTypeKey}/edit`);

  // ref preserves the `open` callback pointer from changing
  const isOpenRef = useRef(isOpen);
  useLayoutEffect(() => {
    isOpenRef.current = isOpen;
  }, [isOpen]);

  const open = useCallback(() => {
    const isOpen = isOpenRef.current;
    const history = historyRef.current;
    const { location } = history;

    if (isOpen) return;
    if (
      location.pathname.includes('/attribute') ||
      location.pathname.includes(PERSON_PROFILE_URL)
    ) {
      history.push({
        ...location,
        pathname: `${HOME_URL}${ATTRIBUTES_URL}/${entityTypeKey}/create`,
      });
    }
  }, []);

  const close = useCallback(() => {
    const isOpen = isOpenRef.current;
    const history = historyRef.current;
    if (!isOpen) return;

    if (entityTypeKey === PERSON_ENTITY_TYPE_KEY) {
      history.push(`/admin${PERSON_PROFILE_URL}/`);
    } else {
      history.push(`${HOME_URL}${DYNAMIC_PAGES_URL}/${entityTypeKey}/attributes`);
    }
  }, []);

  return {
    isOpen,
    open,
    close,
  };
}
